import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { PROMOS } from "../data";

const STORAGE_KEY = "organo_promo_dismissed_v1";

export default function PromoBar() {
  const [idx, setIdx] = useState(0);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
  });

  useEffect(() => {
    if (dismissed) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % PROMOS.length), 4500);
    return () => clearInterval(t);
  }, [dismissed]);

  if (dismissed) return null;
  const promo = PROMOS[idx];

  return (
    <div
      data-testid="promo-bar"
      className="relative z-50 bg-ink text-bone border-b border-bone/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-10 md:px-6 min-h-9 py-1.5 md:py-0 md:h-9 flex items-center justify-center text-center relative">
        <div key={idx} className="fade-in flex items-center gap-2 text-[10.5px] md:text-[12px] tracking-[0.16em] md:tracking-[0.18em] uppercase font-medium leading-snug">
          <span aria-hidden className="text-butter flex-shrink-0">{promo.icon}</span>
          <span className="line-clamp-2 md:line-clamp-1">{promo.text}</span>
        </div>
        <button
          data-testid="promo-bar-dismiss"
          onClick={() => {
            setDismissed(true);
            try {
              localStorage.setItem(STORAGE_KEY, "1");
            } catch (err) {
              console.warn("PromoBar: failed to persist dismissal", err);
            }
          }}
          className="absolute right-2 md:right-4 h-7 w-7 grid place-items-center text-bone/60 hover:text-coral transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
